import type { ReactNode } from "react";

import ResumenSection from "./sections/ResumenSection";
import CentroMonitoreoSection from "./sections/CentroMonitoreoSection";
import UnidadesSection from "./sections/UnidadesSection";
import GeocercasSection from "./sections/GeocercasSection";
import RutasSection from "./sections/RutasSection";
import ViajesSection from "./sections/ViajesSection";
import ConfigurarSection from "./sections/ConfigurarSection";
import ProtocolosSection from "./sections/ProtocolosSection";
import UsoConsumoSection from "./sections/UsoConsumoSection";

export interface MonitoreoIaNavItem {
  id: string;
  labelKey: string;
  icon: string;
  element: ReactNode;
  hiddenFromMenu?: boolean;
}

export const MENU: MonitoreoIaNavItem[] = [
  {
    id: "resumen",
    labelKey: "monitoreoIa.menu.resumen",
    icon: "ri-dashboard-line",
    element: <ResumenSection />,
  },
  {
    id: "centro-monitoreo",
    labelKey: "monitoreoIa.menu.centroMonitoreo",
    icon: "ri-radar-line",
    element: <CentroMonitoreoSection />,
  },
  {
    id: "unidades",
    labelKey: "monitoreoIa.menu.unidades",
    icon: "ri-truck-line",
    element: <UnidadesSection />,
  },
  {
    id: "geocercas",
    labelKey: "monitoreoIa.menu.geocercas",
    icon: "ri-map-pin-5-line",
    element: <GeocercasSection />,
  },
  {
    id: "rutas",
    labelKey: "monitoreoIa.menu.rutas",
    icon: "ri-route-line",
    element: <RutasSection />,
  },
  {
    id: "viajes",
    labelKey: "monitoreoIa.menu.viajes",
    icon: "ri-road-map-line",
    element: <ViajesSection />,
  },
  {
    id: "configurar",
    labelKey: "monitoreoIa.menu.configurar",
    icon: "ri-robot-2-line",
    element: <ConfigurarSection />,
  },
  {
    id: "protocolos",
    labelKey: "monitoreoIa.menu.protocolos",
    icon: "ri-file-list-3-line",
    element: <ProtocolosSection />,
    hiddenFromMenu: true,
  },
  {
    id: "uso-consumo",
    labelKey: "monitoreoIa.menu.usoConsumo",
    icon: "ri-pie-chart-line",
    element: <UsoConsumoSection />,
  },
];

export const MONITOREO_IA_BASE = "/monitoreo-ia";

export const monitoreoIaDefaultRoute = `${MONITOREO_IA_BASE}/${MENU[0].id}`;

export const monitoreoIaApp = {
  id: "monitoreo-ia",
  iconClass: "ri-shield-check-line",
  color: "bg-purple-500",
  route: monitoreoIaDefaultRoute,
};
